import React from 'react';
import styled from '@emotion/styled';
import { HiddenFocus, ITheme } from '../../../../../ui';
import { Item } from './item';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { PoiListStore } from '../../../domain/stores';
import { IPoi } from '../../../domain/models/IPoi';
import themed from '../../../../../ui/themer/themed';

export const StyledPoiList = styled.div<{}, ITheme>`
	margin: 24px 0;

	@media (max-width: 720px) {
		margin: 10px 0;
		border-top: ${themed(({ border }) => border.default)};
	}
`;

export interface IPoiListProps {
	results: IPoi[];
	previousIndex: number;
}

export const PoiList = ({ results, previousIndex }: IPoiListProps) => {
	const { t } = useTranslation();

	return (
		<StyledPoiList>
			{results.map((poi, index) => (
				<React.Fragment key={poi.poiId}>
					{index === previousIndex && (
						<HiddenFocus>
							{t('showing_more_items_sr', {
								amount: PoiListStore.DEFAULT_SHOW_MORE_BATCH_LENGTH,
							})}
						</HiddenFocus>
					)}
					<Item key={poi.poiId} poi={poi} />
				</React.Fragment>
			))}
		</StyledPoiList>
	);
};
